module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.secureaccount', {
            abstract: true
        })
        .state('shop.secureaccount.form', {
            url: '/secure-account',
            params: {
                redirect: null
            },
            views: {
                'center-panel@': {
                    template: '<bws-secure-user-account-form></bws-secure-user-account-form>'
                }
            },
            data: {
                analytics: 'bws:web:my account:secure user account',
                authenticate: true,
                isSecurePasswordFlow: true,
                pageMetadata: {
                    title: 'Secure your account',
                    metaDescription: 'Secure your account'
                }
            }
        })
        .state('shop.secureaccount.confirmation', {
            url: '/secure-account-confirmation',
            params: {
                redirect: null
            },
            views: {
                'center-panel@': {
                    template: '<bws-secure-user-account-confirmation></bws-secure-user-account-confirmation>'
                }
            },
            data: {
                analytics: 'bws:web:my account:secure user account confirmation',
                authenticate: true,
                isSecurePasswordFlow: true,
                pageMetadata: {
                    title: 'Secure your account confirmation',
                    metaDescription: 'Secure your account confirmation'
                }
            }
        });
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/routes/secureaccount.js
 **/